import { TERM_CONDITIONS_TYPES } from 'constants/termsAndConditions'
import { URLS } from 'constants/urls'
import {
  CROSS_BORDER_POLICY,
  DRIVER_CREDIT,
  DRIVER_REQUIREMENTS,
  EXCESS_DEPOSIT,
  FUEL_POLICY,
  INSURANCE_INCLUDED,
  RENTAL_EXCLUDES,
  RENTAL_INCLUDES,
} from 'texts/termsAndConditions'

export const NAVIGATION_ITEMS = [
  {
    url: URLS.RENTAL_INCLUDES,
    label: RENTAL_INCLUDES,
    id: TERM_CONDITIONS_TYPES.RentalIncludes,
  },
  {
    url: URLS.RENTAL_EXCLUDES,
    label: RENTAL_EXCLUDES,
    id: TERM_CONDITIONS_TYPES.RentalExcludes,
  },
  {
    url: URLS.DRIVER_REQUIREMENTS,
    label: DRIVER_REQUIREMENTS,
    id: TERM_CONDITIONS_TYPES.DriverRequirements,
  },
  {
    url: URLS.FUEL_POLICY,
    label: FUEL_POLICY,
    id: TERM_CONDITIONS_TYPES.FuelPolicy,
  },
  {
    url: URLS.CROSS_BORDER_POLICY,
    label: CROSS_BORDER_POLICY,
    id: TERM_CONDITIONS_TYPES.CrossBorderPolicy,
  },
  {
    url: URLS.INSURANCE_INCLUDED,
    label: INSURANCE_INCLUDED,
    id: TERM_CONDITIONS_TYPES.InsuranceIncluded,
  },
  {
    url: URLS.DRIVER_CREDIT,
    label: DRIVER_CREDIT,
    id: TERM_CONDITIONS_TYPES.DriverCreditCard,
  },
  {
    url: URLS.EXCESS_DEPOSIT,
    label: EXCESS_DEPOSIT,
    id: TERM_CONDITIONS_TYPES.ExcessDeposit,
  },
]

export const TERMS_WITHOUTH_HISTORY = [
  TERM_CONDITIONS_TYPES.FuelPolicy,
  TERM_CONDITIONS_TYPES.DriverRequirements,
  TERM_CONDITIONS_TYPES.CrossBorderPolicy,
  TERM_CONDITIONS_TYPES.DriverCreditCard,
]
